/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteMcpServerToolMetadataSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteMcpServerToolMetadataSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteMcpServerToolMetadataSecurity = {
  option1?: DeleteMcpServerToolMetadataSecurityOption1 | undefined;
  option2?: DeleteMcpServerToolMetadataSecurityOption2 | undefined;
};

export type DeleteMcpServerToolMetadataRequest = {
  /**
   * The ID of the MCP server the tool metadata belongs to
   */
  mcpServerId: string;
  /**
   * The name of the tool to delete
   */
  toolName: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteMcpServerToolMetadataSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteMcpServerToolMetadataSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DeleteMcpServerToolMetadataSecurityOption1$Outbound,
    DeleteMcpServerToolMetadataSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteMcpServerToolMetadataSecurityOption1ToJSON(
  deleteMcpServerToolMetadataSecurityOption1:
    DeleteMcpServerToolMetadataSecurityOption1,
): string {
  return JSON.stringify(
    DeleteMcpServerToolMetadataSecurityOption1$outboundSchema.parse(
      deleteMcpServerToolMetadataSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteMcpServerToolMetadataSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteMcpServerToolMetadataSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DeleteMcpServerToolMetadataSecurityOption2$Outbound,
    DeleteMcpServerToolMetadataSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function deleteMcpServerToolMetadataSecurityOption2ToJSON(
  deleteMcpServerToolMetadataSecurityOption2:
    DeleteMcpServerToolMetadataSecurityOption2,
): string {
  return JSON.stringify(
    DeleteMcpServerToolMetadataSecurityOption2$outboundSchema.parse(
      deleteMcpServerToolMetadataSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteMcpServerToolMetadataSecurity$Outbound = {
  Option1?: DeleteMcpServerToolMetadataSecurityOption1$Outbound | undefined;
  Option2?: DeleteMcpServerToolMetadataSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteMcpServerToolMetadataSecurity$outboundSchema: z.ZodMiniType<
  DeleteMcpServerToolMetadataSecurity$Outbound,
  DeleteMcpServerToolMetadataSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteMcpServerToolMetadataSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteMcpServerToolMetadataSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteMcpServerToolMetadataSecurityToJSON(
  deleteMcpServerToolMetadataSecurity: DeleteMcpServerToolMetadataSecurity,
): string {
  return JSON.stringify(
    DeleteMcpServerToolMetadataSecurity$outboundSchema.parse(
      deleteMcpServerToolMetadataSecurity,
    ),
  );
}

/** @internal */
export type DeleteMcpServerToolMetadataRequest$Outbound = {
  mcp_server_id: string;
  tool_name: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteMcpServerToolMetadataRequest$outboundSchema: z.ZodMiniType<
  DeleteMcpServerToolMetadataRequest$Outbound,
  DeleteMcpServerToolMetadataRequest
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
    toolName: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      toolName: "tool_name",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteMcpServerToolMetadataRequestToJSON(
  deleteMcpServerToolMetadataRequest: DeleteMcpServerToolMetadataRequest,
): string {
  return JSON.stringify(
    DeleteMcpServerToolMetadataRequest$outboundSchema.parse(
      deleteMcpServerToolMetadataRequest,
    ),
  );
}
